function StackCarousel({ id, badge, title, subtitle, items, chips, accent = 'cyan' }) {
	const loopItems = [...items, ...items];

	const accentMap = {
		cyan: {
			badge: 'bg-cyan-100 text-cyan-700',
			title: 'text-cyan-700',
			tag: 'text-cyan-700',
		},
		indigo: {
			badge: 'bg-indigo-100 text-indigo-700',
			title: 'text-indigo-700',
			tag: 'text-indigo-700',
		},
	};

	const styles = accentMap[accent] || accentMap.cyan;

	return (
		<section id={id} className="rounded-3xl bg-white px-5 py-12 shadow-sm ring-1 ring-slate-200 sm:px-7 lg:px-8">
			<div className="mb-8">
				<span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold tracking-[0.14em] uppercase ${styles.badge}`}>
					• {badge}
				</span>
				<h2 className="mt-3 text-3xl font-bold text-slate-900 sm:text-4xl">
					{title.split(' ').slice(0, -1).join(' ')}{' '}
					<span className={styles.title}>{title.split(' ').slice(-1)}</span>
				</h2>
				<p className="mt-3 max-w-3xl text-base text-slate-600 sm:text-lg">{subtitle}</p>
			</div>

			<div className="overflow-x-auto rounded-2xl border border-slate-200 bg-slate-50 p-2">
				<div className="stack-loop">
					{loopItems.map((item, idx) => (
						<article
							key={`${item.name}-${idx}`}
							className="min-w-[260px] rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:min-w-[290px]"
						>
							<div className="flex items-center gap-3">
								<div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-slate-100 p-2">
									<img src={item.icon} alt={item.name} className="h-8 w-8 object-contain" loading="lazy" />
								</div>
								<div>
									<h3 className="text-2xl font-semibold text-slate-900">{item.name}</h3>
									<p className={`text-xs font-semibold uppercase tracking-wide ${styles.tag}`}>{item.category}</p>
								</div>
							</div>
							<p className="mt-4 text-sm text-slate-600">{item.description}</p>
						</article>
					))}
				</div>
			</div>

			<div className="mt-7 rounded-2xl border border-slate-200 bg-slate-50 p-3">
				<div className="flex flex-wrap gap-2">
					{chips.map((chip) => (
						<span key={chip} className="rounded-full border border-slate-200 bg-white px-3 py-1.5 text-sm text-slate-700">
							{chip}
						</span>
					))}
				</div>
			</div>
		</section>
	);
}

export default StackCarousel;
